"use strict"; // Copyright 2014 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IAMAuth = void 0;

var IAMAuth = /*#__PURE__*/function () {
  /**
   * IAM credentials.
   *
   * @param selector the iam authority selector
   * @param token the token
   * @constructor
   */
  function IAMAuth(selector, token) {
    _classCallCheck(this, IAMAuth);

    this.selector = selector;
    this.token = token;
    this.selector = selector;
    this.token = token;
  }
  /**
   * Acquire the HTTP headers required to make an authenticated request.
   */


  _createClass(IAMAuth, [{
    key: "getRequestHeaders",
    value: function getRequestHeaders() {
      return {
        'x-goog-iam-authority-selector': this.selector,
        'x-goog-iam-authorization-token': this.token
      };
    }
  }]);

  return IAMAuth;
}();

exports.IAMAuth = IAMAuth;